import request from '@/utils/request'

export function loginAmrep (data) {
  return request({
    url: '/amrep/login/login',
    method: 'post',
    data
  })
}

export function loginQRcode () {
  return request({
    url: '/amrep/login/loginQRcode',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js